module.exports = __webpack_public_path__ + "static/media/climbing.3d872324.svg";